import Swiper, { A11y, Navigation } from 'swiper';
import { isAtLeast } from '../utils/_breakpoints.js';

class mBtnSliderSize extends HTMLDivElement {
    constructor() {
        super();
        this.sliderSize = {};
        this.slider = null;
        this.sliderInitialised = false;
        this.container = this.querySelector('.swiper-container');
        this.wrapper = this.querySelector('.swiper-wrapper');
        this.navPrev = this.querySelector('.swiper-button-prev');
        this.navNext = this.querySelector('.swiper-button-next');
        this.slidePerView = getComputedStyle(this).getPropertyValue('--slide-per-view');
    }

    connectedCallback() {
        this.listenResize();
        this.switchSlider();
        if (document.readyState !== 'complete') {
            // Reload slider to fix arrows display
            document.addEventListener('readystatechange', (e) => {
                if (e.target.readyState === 'complete') {
                    this.switchSlider();
                }
            });
        }
    }

    listenResize() {
        window.addEventListener('resize', () => {
            this.switchSlider();
        });
    }

    switchSlider() {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }

        if (isAtLeast('md')) {
            if (
                this.wrapper.childElementCount > this.slidePerView ||
                this.wrapper.scrollWidth > this.wrapper.clientWidth
            ) {
                this.initSliderDesktop();
                this.classList.remove('no-slider');
            } else {
                this.classList.add('no-slider');
            }
        }

        if (!this.sliderInitialised) {
            this.navPrev.remove();
            this.navNext.remove();
        }
    }

    initSliderDesktop() {
        this.slider = new Swiper(this.container, {
            modules: [A11y, Navigation],
            spaceBetween: 0,
            // To change number of size per view, change the
            // SCSS value "$slide-per-view" in _m-plp-tile-slider-size.scss
            slidesPerView: 'auto',
            loop: false,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navNext,
                prevEl: this.navPrev
            },
            a11y: {
                prevSlideMessage: this.dataset.a11ySlidePrev,
                nextSlideMessage: this.dataset.a11ySlideNext
            },
            paginationElement: 'button'
        });

        // Set width on each slide
        this.slider.slides.forEach((slide) => {
            const contentWidth = slide.children[0].clientWidth;
            slide.style.setProperty('--slide-width', contentWidth);
        });

        this.sliderInitialised = true;
    }
}

customElements.define('m-plp-tile-slider-size', mBtnSliderSize, {
    extends: 'div'
});
